import { gameState } from "appworks/model/game-state";
import { Contract } from "appworks/utils/contracts/contract";
import { Sequence } from "appworks/utils/contracts/sequence";
import { gamevy } from "gamevy/gamevy";
import { gamevyModel } from "gamevy/gamevy-model";
import RespinResult from "slotworks/model/gameplay/records/results/respin-result";
import { Jurisdiction } from "slotworks/services/jurisdiction/jurisdiction-service";
import { ShowWinLines, ShowWinLinesConfig } from "slotworks/state-machine/standard/states/show-win-lines";

export default class GamevyShowWinLines extends ShowWinLines {
    public static BIG_WIN_COMPLETE_DELAY: number = 1000;

    constructor(config?: Partial<ShowWinLinesConfig>) {
        super(config);

        switch (gamevyModel.jurisdiction) {
            case Jurisdiction.UK:
            case Jurisdiction.Alderney:
                this.config.showTotalWinBelowStake = false;
                break;
            default:
                this.config.showTotalWinBelowStake = true;
                break;
        }
    }

    public onEnter() {
        if (!gamevy.MANUAL_GAME_ROUNDS && !this.respinsPending()) {
            gamevy.gameRoundEnd();
        }

        super.onEnter();
    }

    protected winSequence(): Contract<void> {
        const contracts = [
            () => super.winSequence()
        ];

        if (this.bigWinTriggered()) {
            contracts.push(
                () => Contract.getTimeoutContract(GamevyShowWinLines.BIG_WIN_COMPLETE_DELAY)
            );
        }

        return new Sequence(contracts);
    }

    protected respinsPending(): boolean {
        const result = gameState.getCurrentGame().getLatestResultOfType(RespinResult);
        return result && result.respinsRemaining > 0;
    }
}
